export const DummyProducts = () => {
  const products = [
    {
      id: 1,
      title: "Sandwich 1",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1603901/pexels-photo-1603901.jpeg?cs=srgb&dl=pexels-rajesh-tp-1603901.jpg&fm=jpg",
      price: 100,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
    {
      id: 2,
      title: "Sandwich 2",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1603898/pexels-photo-1603898.jpeg?cs=srgb&dl=pexels-rajesh-tp-1603898.jpg&fm=jpg",
      price: 200,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
    {
      id: 3,
      title: "Sandwich 3",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1647163/pexels-photo-1647163.jpeg?cs=srgb&dl=pexels-erin-wang-1647163.jpg&fm=jpg",
      price: 300,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
    {
      id: 4,
      title: "Sandwich 4",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1603898/pexels-photo-1603898.jpeg?cs=srgb&dl=pexels-rajesh-tp-1603898.jpg&fm=jpg",
      price: 400,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
    {
      id: 1,
      title: "Sandwich 1",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1603901/pexels-photo-1603901.jpeg?cs=srgb&dl=pexels-rajesh-tp-1603901.jpg&fm=jpg",
      price: 100,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
    {
      id: 2,
      title: "Sandwich 2",
      title_ar: "ساندوتش 1",
      image:
        "https://images.pexels.com/photos/1603898/pexels-photo-1603898.jpeg?cs=srgb&dl=pexels-rajesh-tp-1603898.jpg&fm=jpg",
      price: 200,
      description:
        " to customers. ... restaurant guide that has reviews on the restaurants as experienced by the public and provides information on locations and contact",
    },
  ];

  return products;
};
